import { UcFooterInfo } from './uc-footer-info';
import { safeDefine } from 'lm-ui-kit/src/utils/define-element';

safeDefine('uc-footer-info', UcFooterInfo);
